export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";